import { useState, type ReactElement } from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router';
import { creerProjet, deriverCode } from '../projets.js';
import { EchecApi } from '../api.js';
import { CHEMINS } from '../routes.js';

interface Espace { readonly code: string; readonly nom: string; readonly role: string }

/**
 * CREER UN PROJET [29-C].
 *
 * LE CODE SUIT LE NOM JUSQU A LA PREMIERE EDITION MANUELLE, puis cesse de le
 * suivre. Ecraser un choix explicite serait le pire des services : le code
 * entre dans l URL et ne pourra plus changer.
 *
 * La derivation est un CONFORT. Le serveur revalide le format ET l unicite ;
 * il ne fait jamais confiance au slug du navigateur [29-C, decision 2.a].
 */
export function NouveauProjet(): ReactElement {
  const espace = useOutletContext<Espace>();
  const navigate = useNavigate();
  const [nom, setNom] = useState('');
  const [code, setCode] = useState('');
  const [codeTouche, setCodeTouche] = useState(false);
  const [description, setDescription] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | undefined>(undefined);

  const pret = nom.trim() !== '' && code.trim() !== '' && !envoi;

  const surNom = (v: string): void => {
    setNom(v);
    if (!codeTouche) setCode(deriverCode(v));
  };

  const surCreer = async (): Promise<void> => {
    setEnvoi(true); setErreur(undefined);
    try {
      const r = await creerProjet(espace.code, {
        nom: nom.trim(), code: code.trim(),
        description: description.trim() === '' ? undefined : description.trim() });
      navigate(CHEMINS.projet(espace.code, r.projet.code));
    } catch (e) {
      const c = e instanceof EchecApi ? e.detail.code : '';
      setErreur(c === 'code_projet_deja_pris'
        ? 'Ce code est deja utilise par un projet de cet espace.'
        : c === 'droit_insuffisant'
          ? 'Votre role ne permet pas de creer un projet ici.'
          : e instanceof Error ? e.message : 'Echec inattendu.');
    } finally { setEnvoi(false); }
  };

  return (
    <section>
      <p><Link to={CHEMINS.projets(espace.code)}>&larr; Projets</Link></p>
      <h1>Nouveau projet</h1>
      <label>Nom du projet
        <input value={nom} onChange={(e) => surNom(e.target.value)}
          placeholder="Salle Eden" /></label>
      <p className="discret">Le nom lisible, tel qu il s affichera partout.
        Accents, espaces et majuscules sont permis.</p>
      <label>Code
        <input value={code} placeholder="salle-eden"
          onChange={(e) => { setCodeTouche(true); setCode(e.target.value); }} /></label>
      <p className="discret">Propose d apres le nom, et modifiable. Il apparait
        dans l adresse du navigateur et ne pourra plus changer. Minuscules,
        chiffres et tirets uniquement, sans espace ni accent.</p>
      <label>Description
        <input value={description}
          onChange={(e) => setDescription(e.target.value)} /></label>
      <p className="discret">Facultative. Une phrase pour situer ce projet.</p>
      {erreur !== undefined && <p className="message message--refus">{erreur}</p>}
      <p><button className="bouton" disabled={!pret}
        onClick={() => { void surCreer(); }}>Creer le projet</button></p>
    </section>
  );
}
